module.exports = __webpack_public_path__ + "static/media/lock-open.f174c12d.svg";